// extracted by mini-css-extract-plugin
module.exports = {"titleTreatment":"u9"};